import { Icon } from '@amili-v3/amili-v3-design';
import { useTranslation } from 'react-i18next';
import AuthCardHeader from '../AuthCardHeader';
import { AuthHelperText, AuthModal } from '../styles';
import { LockIconWrapper } from './styles';

const TwoFactorAuthenConfirm = () => {
  const { t } = useTranslation();

  return (
    <AuthModal
      centered
      open={true}
      mask={false}
      width={420}
      footer={null}
      hideCloseButton
      layout="vertical"
      footerBorder={false}
      title={
        <AuthCardHeader heading={t('authentication.twoFactorAuthentication')} />
      }
    >
      <LockIconWrapper>
        <Icon name="lock" width={30} height={36} />
      </LockIconWrapper>
      <AuthHelperText>{t('authentication.twoFactorHelp')}</AuthHelperText>
    </AuthModal>
  );
};

export default TwoFactorAuthenConfirm;
